import './App.css';
import Header from './components/Header/Header.js'
import Home from './components/Home/Home.js';
import Footer from './components/Footer/Footer.js';
import LeftSideBar from './components/LeftSideBar/LeftSideBar.js';
import RightSideBar from './components/RightSideBar/RightSideBar.js';
import PageNotFound from './components/PageNotFound/PageNotFound';
import GoUp from './components/GoUp/GoUp';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
function App() {
  return (
      <>
        <Router>
         <Header/>
         <LeftSideBar />
         <RightSideBar />
         <GoUp />
        <div className="container">
        <Routes>
         <Route path='/' exact element={<Home />} />
         <Route path="*" element={<PageNotFound />} />
         </Routes>
        </div>
         <Footer />
         </Router>
      </>
  );
}

export default App;
